import { useState } from 'react';
import { Link } from 'react-router-dom';

export function FAQ({ t }) {
  const items = [
    { q: t.faqQ1, a: t.faqA1 },
    { q: t.faqQ2, a: t.faqA2 },
    { q: t.faqQ3, a: t.faqA3 },
    { q: t.faqQ4, a: t.faqA4 },
    { q: t.faqQ5, a: t.faqA5 },
    { q: t.faqQ6, a: t.faqA6 },
    { q: t.faqQ7, a: t.faqA7 },
  ];

  const [open, setOpen] = useState(0);
  const toggle = (i) => setOpen(open === i ? -1 : i);

  return (
    <section className="ssi-faq" style={faqStyles.wrap}>
      <div className="ssi-faq__inner" style={faqStyles.inner}>
        <aside className="ssi-faq__side" style={faqStyles.side}>
          <div style={faqStyles.kicker}>{t.faqKicker}</div>
          <h2 style={faqStyles.h2}>{t.faqTitle}</h2>
          <p style={faqStyles.lede}>{t.faqLede}</p>
          <div style={faqStyles.contact}>
            <div style={faqStyles.contactLabel}>Still unsure?</div>
            <Link to="/contact" style={faqStyles.contactLink}>{t.faqContact}</Link>
          </div>
        </aside>

        <ol className="ssi-faq__list" style={faqStyles.list}>
          {items.map((it, i) => {
            const isOpen = open === i;
            return (
              <li key={i} style={{
                ...faqStyles.item,
                borderColor: isOpen ? 'var(--brandRed)' : 'var(--border)',
                background: isOpen ? '#fff' : 'transparent',
                boxShadow: isOpen ? '0 8px 24px rgba(178,25,45,.08)' : 'none',
              }}>
                <button
                  type="button"
                  onClick={() => toggle(i)}
                  aria-expanded={isOpen}
                  style={faqStyles.qBtn}>
                  <span style={faqStyles.qNum}>{String(i+1).padStart(2,'0')}</span>
                  <span style={faqStyles.qText}>{it.q}</span>
                  <span style={{
                    ...faqStyles.qIcon,
                    transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)',
                    color: isOpen ? 'var(--brandRed)' : 'var(--grey)',
                  }} aria-hidden>+</span>
                </button>
                <div style={{
                  ...faqStyles.aWrap,
                  maxHeight: isOpen ? 400 : 0,
                  opacity: isOpen ? 1 : 0,
                }}>
                  <p style={faqStyles.aText}>{it.a}</p>
                </div>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}

const faqStyles = {
  wrap: { background:'var(--offWhite)', padding:'104px 32px 96px' },
  inner: { maxWidth:1200, margin:'0 auto', display:'grid', gridTemplateColumns:'340px 1fr', gap:64, alignItems:'start' },

  side: { position:'sticky', top:40 },
  kicker: { fontSize:12, letterSpacing:'.14em', textTransform:'uppercase', color:'var(--brandRed)', fontWeight:600, marginBottom:12 },
  h2: { fontFamily:'var(--font-display)', fontSize:44, lineHeight:1.05, margin:'0 0 14px', letterSpacing:'-.015em' },
  lede: { fontSize:16, color:'var(--grey)', lineHeight:1.6, margin:'0 0 28px', textWrap:'pretty' },
  contact: { borderTop:'1px solid var(--border)', paddingTop:20 },
  contactLabel: { fontSize:13, color:'var(--grey)', marginBottom:6 },
  contactLink: { fontSize:16, color:'var(--brandRed)', fontWeight:600, textDecoration:'none' },

  list: { listStyle:'none', margin:0, padding:0, display:'flex', flexDirection:'column', gap:12 },
  item: {
    border:'1px solid var(--border)', borderRadius:14,
    transition:'border-color 160ms ease, background 160ms ease, box-shadow 160ms ease',
    overflow:'hidden',
  },
  qBtn: {
    display:'grid', gridTemplateColumns:'auto 1fr auto',
    alignItems:'center', gap:20,
    width:'100%', padding:'22px 26px',
    background:'transparent', border:0, cursor:'pointer', textAlign:'left',
    font:'inherit', color:'inherit',
  },
  qNum: { fontFamily:'var(--font-display)', fontSize:14, color:'var(--brandRed)', opacity:.7, letterSpacing:'.05em' },
  qText: { fontFamily:'var(--font-display)', fontSize:20, lineHeight:1.3, color:'var(--fg-1)', letterSpacing:'-.005em', textWrap:'balance' },
  qIcon: { fontSize:26, fontWeight:300, width:28, textAlign:'center', transition:'transform 200ms ease, color 160ms ease' },
  aWrap: { overflow:'hidden', transition:'max-height 260ms ease, opacity 200ms ease' },
  aText: { margin:0, padding:'0 26px 26px 82px', fontSize:16, lineHeight:1.65, color:'var(--grey)', textWrap:'pretty' },
};
